<template>
    <!-- regional booster area -->
    <div class="searchCard">
        <div class="searchCard__box searchCard__boxRegionalBoost">
            <div class="searchCard__head flex flex__justifyItems--start flex__alignItems--center">
                <svg
                    class="searchIcon--32 searchIcon__right"
                    height="32"
                    width="32"
                    aria-hidden="true">
                    <use href="#iconBoostDuo" />
                </svg>
                <span class="searchCard__headline">
                    {{ trans('FORM_SEARCH_REGION_FOCUS') }}
                </span>
            </div>
            <!-- regional description text-->
            <div class="facetedSearch__subHeadline flex flex__justifyItems--start flex__alignItems--center">
                {{ trans('FORM_SEARCH_REGION_FOCUS_DESCRIPTION') }}
            </div>
            <CustomDropdown
                id="inlineDropdown__regionalFocus"
                datasty-gtm="regional--focus"
                :default="filterOptions[0]"
                :value="filterOption"
                :disabled="hideFocusFilter"
                :options="filterOptions"
                element="rf-"
                :bordered="true"
                @changeValue="selectFilter" />
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import CustomDropdown from './searchDropdown.vue';
    import Translator from 'tools/trans';
    const IDRELEVANCE = 'idrelevance';
    const FOCUS_DEFAULT = '-1';
    export default {
        name: 'RegionalBooster',
        components: {
            CustomDropdown,
        },
        computed: {
            ...mapGetters('search', [
                'focus',
                'countries',
                'sort',
            ]),
            sortOption() {
                return this.sort || IDRELEVANCE;
            },
            filterOption() {
                return this.focus || FOCUS_DEFAULT;
            },
            filterOptions() {
                return this.countries.map(item => {
                    return {
                        value: item.value,
                        name: Translator.trans(item.label),
                    };
                });
            },
            hideFocusFilter() {
                return this.sortOption !== IDRELEVANCE;
            },
        },
        methods: {
            ...mapActions('search', [
                'resetPageNumber',
                'setFocus',
            ]),
            trans: Translator.trans,
            async selectFilter(option) {
                await this.resetPageNumber();
                this.setFocus(option);
            },
        },
    };
</script>
